import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const VendorPaymentFilter = ({
  applyFilter,
  siteTypes = [],
  assignedAreas = [],
  reportees = [],
  siteStatus = [],
  city = []
}) => {
  const filterInputs = {
    
    vendor_name: '',
    invoice_number:'',
    status_id: '',
    fromDate: "",
    toDate: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);


  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };

  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.vendorName}
        value={filterFieldsData.vendor_name}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, vendor_name: val })
        }
      />
      <ConstantInput
        label={localization.invoiceNo}
        value={filterFieldsData.invoice_number}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, invoice_number: val })
        }
      />
     
   
      {siteStatus.length !== 0 ? 
      <DropDownInput
      disabled={siteStatus.length === 0}
      label={localization.status}
      data={siteStatus}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, status_id: val.id })
      }
    />
      : ''}
     <fieldset>
        <h4>{localization.createdBetween}</h4>

        <FormGroup
          className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange2}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous2(true)}
            onHide={handleDateHide2}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />
          <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
          className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange3}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous3(true)}
            onHide={handleDateHide3}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset>
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default VendorPaymentFilter;
